import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

let app;
let messagingInstance = null;

// Verificar si el navegador soporta las APIs necesarias
const isBrowserSupported = () => {
  if (typeof window === 'undefined') return false;
  return (
    'serviceWorker' in navigator &&
    'Notification' in window &&
    'indexedDB' in window
  );
};

if (isBrowserSupported()) {
  try {
    app = initializeApp(firebaseConfig);
    messagingInstance = getMessaging(app);
  } catch (error) {
    console.warn('Firebase Messaging no disponible en este navegador:', error);
    messagingInstance = null;
  }
}

// Initialize Firebase - función lazy para obtener messaging
export const getMessagingInstance = () => {
  if (isBrowserSupported() && messagingInstance) {
    return messagingInstance;
  }
  return null;
};
